import React from 'react';
import { PropTypes } from 'prop-types';

import Filter from '~COMPONENTS/filters/Filter';
import { renderCheckboxes } from '../filters/Filters';

const Facets = ({ facets, selectFacet, selected, clearSelectedFacet }) => {
  function handleClick(name, isSelecting) {
    const typeAndKey = name.split('facets.')[1].split('--');
    const type = typeAndKey[0];
    const key = typeAndKey[1];

    return !isSelecting ? clearSelectedFacet(type) : selectFacet({ key: type, value: key });
  }

  return (
    <div>
      {facets.map(({ key, values }) => {
        if (key.toLowerCase() === 'gender') {
          const kidsKey = 'kids';
          const kidsValues = ['BOYS', 'GIRLS'].filter(value => values.includes(value));
          const genderValues = ['MENS', 'WOMENS', 'UNISEX'].filter(value => values.includes(value));
          return (
            <>
              {genderValues.length ? (
                <Filter key={key} trigger={`gridwall.facets.${key.toLowerCase()}`}>
                  {renderCheckboxes(
                    `facets.${key}`,
                    genderValues,
                    [selected?.[key]],
                    handleClick,
                    false,
                    'gridwall',
                    true
                  )}
                </Filter>
              ) : null}
              {kidsValues.length ? (
                <Filter key={kidsKey} trigger={`gridwall.facets.${kidsKey.toLowerCase()}`}>
                  {renderCheckboxes(
                    `facets.${key}`,
                    kidsValues,
                    [selected?.[key]],
                    handleClick,
                    false,
                    'gridwall',
                    true
                  )}
                </Filter>
              ) : null}
            </>
          );
        }
        return values.length ? (
          <Filter key={key} trigger={`gridwall.facets.${key.toLowerCase()}`}>
            {renderCheckboxes(`facets.${key}`, values, [selected?.[key]], handleClick, false, 'gridwall', true)}
          </Filter>
        ) : null;
      })}
    </div>
  );
};

Facets.propTypes = {
  facets: PropTypes.array.isRequired,
  clearSelectedFacet: PropTypes.func.isRequired,
  selectFacet: PropTypes.func.isRequired,
  selected: PropTypes.object.isRequired
};

export default Facets;
